<ion-content scrollbar *ngIf="!showLoader" class="modal-outher-container">
  <ion-grid class="modal-inner-container modal-inner-container--scroll">
    <ion-row>
      <ion-col>
        <app-modal-header [header]="headerText" (close)="close()">
        </app-modal-header>
        <form [formGroup]="form" (ngSubmit)="onAssignCompanyOrEmployee()">
          <ion-grid>
            <ion-row *ngIf="permissionAllCompanyEdit">
              <ion-col>
                <div
                  class="control-display"
                  [ngClass]="{
                    'control-display--invalid':
                      form.get('company').hasError('required') &&
                      (form.get('company').touched || validationError)
                  }"
                >
                  <ion-label>{{ 'SPACE.COMPANY' | translate }}*</ion-label>
                  <app-select-dropdown
                    formControlName="company"
                    [data]="dropdownData"
                    (changeValueEvent)="onCompanyChange($event)"
                    (touchEvent)="onSelectTouched('company')"
                  ></app-select-dropdown>
                </div>
                <ion-label
                  *ngIf="
                    form.get('company').hasError('required') &&
                    (form.get('company').touched || validationError)
                  "
                  color="danger"
                  class="font-size__16"
                >
                  {{ 'SPACE.REQUIRED_VALIDATION' | translate }}
                </ion-label>
              </ion-col>
            </ion-row>
            <!-- Group field -->
            <ion-row>
              <ion-col>
                <div class="control-display">
                  <ion-label>{{ 'SPACE.GROUP' | translate }}</ion-label>
                  <app-select-dropdown
                    formControlName="group"
                    displayKey="name"
                    [data]="groupDropdownData"
                    (changeValueEvent)="onGroupChange($event)"
                    [isDisabled]="groupDropdownData?.length < 1"
                  ></app-select-dropdown>
                </div>
              </ion-col>
            </ion-row>
            <!-- End group field -->
            <ion-row *ngIf="showUserDropdown">
              <ion-col>
                <div class="control-display">
                  <ion-label>{{ 'SPACE.USER' | translate }}</ion-label>
                  <app-select-user
                    #userSelect
                    (changeValueEvent)="onUserChange($event)"
                    [data]="usersList"
                    [disabled]="
                      usersList?.length < 1 || form.value.company.id === null
                    "
                    formControlName="user"
                    [formControl]="form.controls.user"
                    [allowClear]="false"
                    [class]="'margin-top-0'"
                    [allUserSelection]="true"
                  ></app-select-user>
                  <!-- <app-select-dropdown
                    formControlName="user"
                    displayKey="email"
                    [data]="usersList"
                    (changeValueEvent)="onUserChange($event)"
                    [isDisabled]="usersList?.length < 1"
                  ></app-select-dropdown> -->
                </div>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="showRegistrationNumberInput">
              <ion-col size="12">
                <app-input
                  type="input"
                  [form]="form"
                  formControlName="number"
                  label="SPACE.PARKING.PLATE_NUMBER"
                  [disabled]="!isUserSelected"
                  [ngClass]="{ isDisabled: !isUserSelected }"
                  [submittedError]="validationError"
                ></app-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="6">
                <div class="control-display">
                  <ion-label>{{
                    'SPACE.ASSIGNMENT_START' | translate
                  }}</ion-label>
                  <app-date-time-picker
                    [value]="startDate"
                    placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
                    (afterPickerClosed)="afterPickerClosed($event, 'start')"
                  ></app-date-time-picker>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6">
                <div class="control-display">
                  <ion-label>{{
                    'SPACE.ASSIGNMENT_END' | translate
                  }}</ion-label>
                  <app-date-time-picker
                    [value]="endDate"
                    placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
                    (afterPickerClosed)="afterPickerClosed($event, 'end')"
                  ></app-date-time-picker>
                </div>
              </ion-col>
              <ion-col>
                <ion-label
                  *ngIf="
                    form.hasError('sameDates') ||
                    (validationError && form.hasError('sameDates'))
                  "
                  color="danger"
                  class="font-size__16"
                >
                  {{ 'SPACE.SAME_DATE' | translate }}
                </ion-label>
                <ion-label
                  *ngIf="
                    ((form.get('dateFrom').touched ||
                      form.get('dateTo').touched) &&
                      form.hasError('startDateBigger')) ||
                    (validationError && form.hasError('startDateBigger'))
                  "
                  color="danger"
                  class="font-size__16"
                >
                  {{ 'SPACE.START_LATER_THAN_END' | translate }}
                </ion-label>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <div class="control-display">
                  <ion-button
                    class="float-right"
                    type="submit"
                    [disabled]="savingAssignment"
                  >
                    <ng-container *ngIf="!savingAssignment">
                      {{ 'SPACE.SAVE' | translate }}
                    </ng-container>
                    <ng-container *ngIf="savingAssignment">
                      {{ 'SAVING' | translate }}
                    </ng-container>
                  </ion-button>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<div class="spin" *ngIf="showLoader">
  <app-loading-sti></app-loading-sti>
</div>
